import React from 'react';
import { PortalOverlay, Content } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { TitleBar } from '@leverege/ui-plugin';
import Screens from './screens';
import Util from './Util';
import S from './ResetLocation.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ResetLocation(props) {
  const {
    onClose,
    show,
    actions,
    mobile,
    item
  } = props;
  const [vehicles, setVehicles] = React.useState();
  const [zones, setZones] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [confirmed, setConfirmed] = React.useState(false);
  const [cancelled, setCancelled] = React.useState(false);
  const [error, setError] = React.useState();
  const [deleting, setDeleting] = React.useState(false);
  const [vehiclesDeleted, setVehiclesDeleted] = React.useState(0);
  const [zonesDeleted, setZonesDeleted] = React.useState(0);
  const [cancelZoneDeletion, setCancelZoneDeletion] = React.useState(null);
  const [cancelVehicleDeletion, setCancelVehicleDeletion] = React.useState(null);
  React.useEffect(() => {
    const execute = async () => {
      setLoading(true);
      const z = await Util.getAllZones(actions);
      setZones(z);
      const v = await Util.getAllVehicles(actions);
      setVehicles(v);
      setLoading(false);
    };
    execute();
  }, []);
  const startDelete = async () => {
    if (deleting) {
      return;
    }
    setLoading(true);
    setDeleting(true);
    const {
      toAwait: vehiclePromise,
      cancel: cancelVehicles
    } = Util.deleteVehicles(actions, vehicles, {
      setVehiclesDeleted
    });
    setCancelVehicleDeletion(() => cancelVehicles);
    let vehicleCancelled, vehicleError;
    try {
      vehicleCancelled = await vehiclePromise;
    } catch (err) {
      vehicleError = err;
    }

    // vehicle deletion was cancelled
    if (vehicleCancelled || vehicleError) {
      setError(vehicleError);
      setCancelled(vehicleCancelled);
      setLoading(false);
      setDeleting(false);
      return;
    }
    const {
      toAwait: zonePromise,
      cancel: cancelZones
    } = Util.deleteZones(actions, zones, {
      setZonesDeleted
    });
    setCancelZoneDeletion(() => cancelZones);
    // const zoneCancelled = await zonePromise

    let zoneCancelled, zoneError;
    try {
      zoneCancelled = await zonePromise;
    } catch (err) {
      zoneError = err;
    }
    setCancelled(zoneCancelled || vehicleCancelled);
    setError(zoneError);
    setLoading(false);
    setDeleting(false);
  };
  const cancel = () => {
    cancelVehicleDeletion?.();
    cancelZoneDeletion?.();
  };
  const screenProps = {
    vehiclesDeleted,
    vehicles,
    zonesDeleted,
    zones,
    cancel,
    setConfirmed,
    startDelete,
    onClose,
    error
  };
  let body;
  if (!confirmed && loading) {
    body = /*#__PURE__*/_jsx(Screens.InitialLoad, {
      ...screenProps
    });
  } else if (!confirmed) {
    body = /*#__PURE__*/_jsx(Screens.Confirmation, {
      ...screenProps
    });
  } else if (confirmed && loading) {
    body = /*#__PURE__*/_jsx(Screens.Resetting, {
      ...screenProps
    });
  } else if (error) {
    body = /*#__PURE__*/_jsx(Screens.ResetFail, {
      ...screenProps
    });
  } else if (cancelled) {
    body = /*#__PURE__*/_jsx(Screens.ResetCancel, {
      ...screenProps
    });
  } else {
    body = /*#__PURE__*/_jsx(Screens.ResetSuccess, {
      ...screenProps
    });
  }
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: mobile ? 'full' : 'center',
    onClose: onClose,
    show: show,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    children: /*#__PURE__*/_jsxs(Content, {
      relative: !mobile,
      variant: "dialog",
      className: S.dialog,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "dialogTitle",
          icon: "https://recovr-ui-assets.storage.googleapis.com/reset.svg",
          title: `Reset ${Attributes.get('name', 'location', item) || 'Location'}`
        })
      }), body]
    })
  });
}
export default ResetLocation;